import { useCallback } from 'react'
import { FieldNames } from 'Src/constants/FieldNames'

export const useIsFieldLocked = (fields: FieldNames[]): ((fieldName: FieldNames) => boolean) =>
	useCallback((fieldName: FieldNames): boolean => fields?.includes(fieldName), [fields])
